<template>
  <div
    v-if="enabledPopUpStation"
  >
    <DxPopup
      :visible="enabledPopUpStation"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :on-hidden="onHidden"
      :show-title="true"
      :show-close-button="true"
      width="auto"
      height="auto"
      :title="$t('registerProject.popPupStation.station_title')"
    >
      <template>
        <form
          id="form"
          :ref="formRefName"
          method="post"
          action=""
          enctype="multipart/form-data"
        >
          <div class="dx-fieldset table">
            <span>
              {{ $t('registerProject.popPupStation.name') }}
            </span>
            <DxTextBox
              name="sampleDate"
              class="dx-field-value"
              value=""
              @value-changed="onChangeName"
            />
            <span>
              {{ $t('registerProject.popPupStation.template') }}
            </span>
            <div class="fileuploader-container">
              <Attach-a-file accept-files=".csv" />
            </div>
            <span>
              {{ 'Descargar CSV de ejemplo' }}
            </span>
            <div class="fileuploader-container">
              <DxButton
                icon="download"
                @click="selection === 'GreenHouse'
                  ? csvExport(templateData) : csvExport(templateDataOpenAir)"
              />
            </div>
            <div
              class="dx-field"
              style="grid-column: 1 / 3"
            >
              <span
                v-if="!checkProvinceSelected"
                style="font-size: small; color: gray;"
              >
                Debe seleccionar una provincia previamente para poder dar de alta una nueva estación
              </span>
              <f7-button
                :class="`dx-btn-success ${validateForm ? '' : 'disabled'}`"
                raised
                type="success"
                styling-mode="contained"
                @click="validateForm ? create() : null"
              >
                {{ $t("add") }}
              </f7-button>
            </div>
          </div>
        </form>
      </template>
    </DxPopup>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import { DxPopup } from 'devextreme-vue/popup';
import DxButton from 'devextreme-vue/button';
import { DxTextBox } from 'devextreme-vue/text-box';
import AttachAFile from './attachAFile.vue';
import Api from '../../../../services/Api';
import EventBus from '../../../../js/event-bus';
import templateOpenAir from './templateOpenAir.json';
import templateGreenHouse from './templateGreenHouse.json';
import { DEVICE_PLATFORM } from '../../../../js/constants';

export default {
  name: 'DxPopUpRegisterPloit',
  components: {
    DxPopup,
    DxTextBox,
    AttachAFile,
    DxButton,
  },
  props: {
    newProjectOA: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      actualPlot: '',
      formRefName: 'tree-view',
      sampleType: ['Agua', 'Suelo', 'Material vegetal', 'Solución suelo', 'Solución Fertilización de riego'],
      files: [],
      base64: '',
      name: '',
      templateData: templateGreenHouse,
      templateDataOpenAir: templateOpenAir,
    };
  },
  computed: {
    validateForm() {
      if (this.selection !== 'GreenHouse') {
        return !!(this.name && this.newProjectOA.province && this.attachment);
      }
      return !!(this.name && this.newProject.province && this.attachment);
    },
    checkProvinceSelected() {
      if (this.selection !== 'GreenHouse') {
        return !!(this.newProjectOA.province);
      }
      return !!(this.newProject.province);
    },
    ...mapState('authentication', ['selection']),
    ...mapState('ProjectGreenHouse', ['enabledPopUpStation', 'newProject', 'attachment']),
  },
  methods: {
    onHidden() {
      this.setEnabledPopUpStation(false);
    },
    onChangeName(e) {
      this.name = e.value;
    },
    async create() {
      try {
        this.$f7.preloader.show();
        const formData = new FormData();
        formData.append('source', this.name);
        if (this.selection !== 'GreenHouse') {
          formData.append('province', this.newProjectOA.province);
        } else {
          formData.append('province', this.newProject.province);
        }
        formData.append('file', this.attachment);
        formData.append('project_type', this.selection === 'GreenHouse' ? 'GH' : 'EX');
        const xhr = await Api.createDatabaseClimateSource(formData);
        const res = JSON.parse(xhr.response);
        console.log(res);
        if (this.selection === 'GreenHouse') {
          EventBus.$emit('selected-station-green-house', res);
        } else {
          EventBus.$emit('selected-station-open-air', res);
        }
        EventBus.$emit('attachedFile');
        this.setEnabledPopUpStation(false);
      } catch (error) {
        console.log(error);
      } finally {
        this.$f7.preloader.hide();
      }
    },
    csvExport(arrData) {
      let csvContent = 'data:text/csv;charset=utf-8,';
      csvContent += [
        Object.keys(arrData[0]).join(';'),
        ...arrData.map((item) => Object.values(item).join(';')),
      ]
        .join('\n')
        .replace(/(^\[)|(\]$)/gm, '');

      const data = encodeURI(csvContent);
      if (DEVICE_PLATFORM === 'android') {
        // create BOM UTF-8
        const buffer = new ArrayBuffer(3);
        const dataView = new DataView(buffer);
        dataView.setUint8(0, 0xfe);
        dataView.setUint8(1, 0xbb);
        dataView.setUint8(2, 0xbf);
        const read = new Uint8Array(buffer);

        const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here
        const header = Object.keys(arrData[0]);
        const csvString = [
          header.join(','), // header row first
          ...arrData.map((row) => header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(',')),
        ].join('\r\n');
        const blob = new Blob([read /* prepend bom */, csvString], { type: 'text/csv;charset=utf-8' });
        const name = this.selection === 'GreenHouse' ? 'Invernadero' : 'Aire Libre';
        cordova.plugins.saveDialog.saveFile(blob, `Plantilla Estación Agroclimática ${name}.csv`).then((uri) => {
          console.info('The file has been successfully saved to', uri);
        }).catch((reason) => {
          console.warn(reason);
        });
      } else {
        const link = document.createElement('a');
        link.setAttribute('href', data);
        link.setAttribute('download', `Plantilla Estación Agroclimática ${this.selection !== 'GreenHouse' ? 'Aire Libre' : 'Invernadero'}.csv`);
        link.click();
      }
    },
    ...mapActions('ProjectGreenHouse', ['setEnabledPopUpStation']),
  },
};
</script>

<style lang="scss" scoped>
.finishedRegister {
}
.center{
  padding-top: 3%;
  font-weight: bold;
}
#form {
    margin: auto;
}

.button {
    margin-top: 20px;
    margin-left: 25%;
    padding-right: 5%;
    width: 50%;
}

.fileuploader-container{
    border: 1px solid #d3d3d3;
}

#form h3 {
    margin-left: 20px;
    font-weight: normal;
    font-size: 22px;
}

.table {
  display: grid;
  grid-template-columns: 1fr 65%;
}
.table > div {
  padding: 5px;
  margin-bottom: 5px;
}
.dx-field-value-static, .dx-field-value:not(.dx-switch):not(.dx-checkbox):not(.dx-button) {
  width: 100%;
}
</style>
